
import currencyMixin from '@/mixins/currency'

export default {
  mixins: [currencyMixin],
  model: {
    event: ['click'],
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    step: {
      type: Number,
      default: 1,
    },
    discount: {
      type: Number,
      default: 0,
    },
    logisticsFee: {
      type: Number,
      default: 0,
    },
    isSubmit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show_description: false,
    }
  },
  computed: {
    showDescriptionText() {
      if (this.show_description) {
        return this.$t('car.hide_description')
      }

      return this.$t('car.show_description')
    },
    iconClass() {
      if (this.show_description) {
        return 'down-icon'
      }

      return 'reverse down-icon'
    },
    isCartStep() {
      return this.step === 1
    },
    isPaymentPageStep() {
      return this.step === 2
    },
    buttonText() {
      if (this.isPaymentPageStep) {
        return this.$t('car.confirm_payment')
      }

      return this.$t('car.go_payment')
    },
    showDiscount() {
      return this.discount > 0
    },
    totalPrice() {
      const total = this.data.reduce((carry, definition) => {
        const { price, quantity } = definition
        carry += price * quantity

        return carry
      }, 0)

      return total - this.discount + this.logisticsFee
    },
  },
  methods: {
    /**
     * @description: Get image style.
     * @param {*} definition
     * @return {*}
     */
    imageStyle(definition) {
      return {
        'background-image': `url(${definition.image})`,
      }
    },
    /**
     * @description: Handle click button.
     * @param {*}
     * @return {*}
     */
    handleClick() {
      this.$emit('click')
    },
  },
}
